import _kebabCase from 'lodash/kebabCase';

export function getGeneratedClassName(pageName) {
  return `custom-page-${_kebabCase(pageName.toLowerCase())}`;
}
